"use strict";
/*
 * Created on 2019-03-21
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author JMr
 */


var SelloutReleasePartConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutReleasePartConverter, _DataObjectConverter_);

  function SelloutReleasePartConverter() {
    _classCallCheck(this, SelloutReleasePartConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleasePartConverter).apply(this, arguments));
  }

  return SelloutReleasePartConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutReleasePartConverter = SelloutReleasePartConverter;